import { createContext, useContext } from "react";
import { useHideTestData } from "@/hooks/useHideTestData";
import { useAuth } from "@/contexts/AuthContext";

const AdminFiltersContext = createContext({ hideTestData: false, setHideTestData: () => {} });

export function AdminFiltersProvider({ children }) {
  const { user } = useAuth();
  const value = useHideTestData(user?.role);
  return <AdminFiltersContext.Provider value={value}>{children}</AdminFiltersContext.Provider>;
}

export function useAdminFilters() {
  return useContext(AdminFiltersContext);
}
